module.exports = "<div class=\"uploadHistory__wrapper\">\n  <p translate>UPLOAD_HISTORY_COPY<p>\n  <table-component columns=\"vm.tab.columns\" row-options=\"vm.rowOptions\" options=\"vm.tab.options\" data=\"vm.data\" refresh-on-show=\"true\"></table-component>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/uploadHistory/uploadHistory.html
// module id = 481
// module chunks = 1